import { useRoutes } from 'react-router-dom';

import { AppRoutes } from './app-routes';
import { LoginRoutes } from './login-routes';

export const CombineRoutes = (): React.ReactElement | null => {
  return useRoutes([LoginRoutes, AppRoutes]);
};
